import React, { useEffect, useState } from 'react' //lazy
import { useHistory, useLocation } from 'react-router-dom'

// import ImgLogo from "assets/images/imgHeader/logo.png";
// import IconUser from "assets/images/imgHeader/IconUser.png";
// import ImgSlider from "assets/images/_group_sale/img_slider.png";
// import { ReactComponent as IconMenu } from "assets/icons/align-justify.svg";
// import { ReactComponent as IconCloseMenu } from "assets/icons/close.svg";
import imageEndFooter from 'assets/images/imageEndFooter.png'
// import bgImg from 'assets/images/Layer-bg.png'
import { deleteLocaStorage, saveLocalStorage } from 'utils/localStorage'
import { UrlInternal } from 'common/constants/endpoints'
// import { listMenu } from "components/Menu";

import { GETME } from 'utils/localStorage/type'

import * as S from './style'
import { useSelector } from 'react-redux'
import {
  HeaderPage,
  BoxLink,
  ListGame,
  ListSport,
  BoxInfo,
  CasinoList,
  FooterPage,
  BestSlipMiniGame,
  PopupConfirm
} from 'components'
import TableDepost from 'pages/Home/TableDeposit'
import TablePayment from 'pages/Home/TablePayment'
import TableCompany from 'pages/Home/TableCompany'
import CustomPartner from 'components/CustomPartner'
import MessageFixed from 'components/MessageFixed'
import Notice from 'components/Notice'
interface Props {
  children?: any
  noImageHeader?: boolean
  type?: 'smallBanner' | 'default'
  typeContent?: 'out' | 'in'
}

const TemplateMypage = ({
  children,
  noImageHeader,
  type = 'default',
  typeContent = 'in'
}: Props) => {
  const history = useHistory()
  const userData: any = localStorage.getItem('User')
  const dataMe = useSelector((state: any) => state.user)
  const path = window.location.pathname
  const [visibleMenuMobile, setVisibleMenuMobile] = useState<boolean>(true)
  const [miniMenuNumber, setMiniMenuNumber] = useState<number>()
  const [isScroll, setScrollStatus] = useState<any>(false)

  // console.log(dataMe);
  useEffect(() => {
    if (!userData) {
      // history.push(UrlInternal.LOGIN)
    }
  }, [userData])

  return (
    <S.Wraper>
      <HeaderPage />
      <MessageFixed />
      <S.Container>
        <Notice />
        {/* <S.LeftMenu>
          <BoxLink />
          <ListGame />
          <ListSport />
        </S.LeftMenu> */}
        <S.Children>{children}</S.Children>
        {userData ? (
          <S.InForCompany>
            <S.InforCompanyChiren>
              <TableCompany />
              <TableDepost />
              <TablePayment />
            </S.InforCompanyChiren>
          </S.InForCompany>
        ) : null}

        <S.footer>
          <S.footerChiren>
            <CustomPartner />
            <FooterPage />
          </S.footerChiren>
        </S.footer>
        <S.footerImage>
          <img src={imageEndFooter} alt='imageEndFooter' />
        </S.footerImage>
        {/* <S.RightMenu>
          <BoxInfo />
          <BestSlipMiniGame />
          <CasinoList />
        </S.RightMenu> */}
      </S.Container>
      <PopupConfirm />
    </S.Wraper>
  )
}

export default TemplateMypage
